import React from "react";
export const BestPicsContext = React.createContext();
